var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',[_c('input',{ref:"autocomplete",staticClass:"form-control",attrs:{"placeholder":_vm.placeholder,"onfocus":"value = ''","type":"search"},on:{"focus":_vm.addressBoxFocused}})])
}
var staticRenderFns = []

export { render, staticRenderFns }